import axiosInstance from '@/utils/axiosInstance';
import { showAlert } from '../components/common/toastify/ToastContainer';
import { handleApiError } from '@/lib/handleApiError';

export const UploadProductFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const res = await axiosInstance.post(
      '/SmartProAPI/api/bts-products/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'File uploaded successfully');
    return res;
  } catch (error) {
    console.log('err', error);
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const downloadBtsProductsFile = async () => {
  try {
    const res = await axiosInstance.get(
      '/SmartProAPI/api/bts-products/download',
      {
        responseType: 'blob', // Important for file download
      },
    );
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'bts-products.csv'); // Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const createSchoolProposal = async (formData) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/school-proposals',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'School created successfully');
    return res.data;
  } catch (error) {
    console.error(error);
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};
export const updateSchoolProposal = async (formData, id) => {
  try {
    const res = await axiosInstance.put(
      '/SmartProAPI/api/school-proposals/' + id,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Proposal updated successfully');
    return res.data;
  } catch (error) {
    console.error(error);
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getSalesReps = async () => {
  try {
    const res = await axiosInstance.get(
      '/SmartProAPI/api/school-proposals/sales-reps',
    );
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getBtsProducts = async (searchTerm) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/bts-products/search?searchTerm=${searchTerm}`,
    );
    if (res.status === 404) {
      res.data = ['No data found'];
      showAlert('info', 'No products found');
    } else if (res.status !== 200) {
      handleApiError(
        'error',
        'Failed to fetch products',
        error?.response?.status,
      );
      throw new Error('Failed to fetch products');
    } else {
      return res.data;
    }
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getBtsProductsByClass = async (schoolProposalId, classId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products?classId=${classId}`,
    );
    if (res.status === 204) {
      return ['No Data Found'];
    }
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const addManualProduct = async (schoolProposalId, classId, product) => {
  try {
    const res = await axiosInstance.post(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/manual?classId=${classId}`,
      product,
    );
    showAlert('success', 'Product added successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const uploadProductFileByClass = async (
  file,
  schoolProposalId,
  classId,
) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const res = await axiosInstance.post(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/upload?classId=${classId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Products uploaded successfully');
    // Fetch updated products after upload
    return res.data;
  } catch (error) {
    // handleApiError('error', error?.response?.data?.message || error?.response?.status);
    console.log(error);
    throw error;
  }
};

export const updateManualProduct = async (
  schoolProposalId,
  classId,
  product,
) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/${product.id}?classId=${classId}`,
      product,
    );
    showAlert('success', 'Product updated successfully');
    // Fetch updated products after updating
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const deleteClassProduct = async (
  schoolProposalId,
  classId,
  productId,
) => {
  try {
    const res = await axiosInstance.delete(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/${productId}?classId=${classId}`,
    );
    showAlert('success', 'Product deleted successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getSchoolProposals = async (
  page,
  size,
  search = '',
  sortBy = '',
  sortDir = 'desc',
) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals?page=${page}&size=${size}&searchTerm=${search}&sortBy=${sortBy}&sortDir=${sortDir}`,
    );
    if (res.status === 204) {
      return ['No Data Found'];
    }
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const deleteSchoolProposal = async (id) => {
  try {
    const res = await axiosInstance.delete(
      `/SmartProAPI/api/school-proposals/${id}`,
    );
    showAlert('success', 'Proposal deleted successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportBTSExcel = async (schoolProposalId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-proposal`,
      {
        responseType: 'blob', // Important for file download
      },
    );
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'bts-export-report.xlsx'); // Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.log(error);
    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const deleteMultipleProductByClass = async (
  schoolProposalId,
  classId,
  productIds,
) => {
  try {
    const res = await axiosInstance.delete(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products?classId=${classId}`,
      { data: productIds }, // send as raw array
    );
    showAlert('success', 'Products deleted successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportParentsInstruction = async (schoolProposalId, classId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-parents-instruction?classId=${classId}`,
      {
        responseType: 'blob', // Important for file download
      },
    );
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'parents-instruction.docx'); // Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.log(error);
    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportPdf = async (schoolProposalId, classId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-booklist-pdf?classId=${classId}`,
      {
        responseType: 'blob', // Important for file download
      },
    );
    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'application/pdf' }),
    );
    window.open(url, '_blank');
  } catch (error) {
    console.log(error);
    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportBtsShReport = async (schoolProposalId, schoolName) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-bts-sh-report`,
      {
        responseType: 'blob',
      },
    );
    if (res.status === 204) {
      showAlert('warn', 'No products associated with this proposal');
      return;
    }

    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'text/csv;charset=utf-8;' }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `step-1 ${schoolName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert('success', 'Step-1 report downloaded successfully');
  } catch (error) {
    console.error(error);

    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const kitImportTemplateReport = async (schoolProposalId, schoolName) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/kit-import-template-report`,
      {
        responseType: 'blob',
      },
    );
    if (res.status === 204) {
      showAlert('warn', 'No products associated with this proposal');
      return;
    }

    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'text/csv;charset=utf-8;' }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `step-3 ${schoolName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert('success', 'Step-3 report downloaded successfully');
  } catch (error) {
    console.error(error);

    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const getClassListForProposal = async (schoolProposalId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/class-list`,
    );
    if (res.status === 204) {
      return [];
    }
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const saveCategoryCode = async (schoolProposalId, data, schoolName) => {
  try {
    const res = await axiosInstance.post(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/bts-step2-report`,
      data,
      {
        responseType: 'blob',
      },
    );
    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'text/csv;charset=utf-8;' }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `step-2 ${schoolName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert('success', 'Step-2 report downloaded successfully');
    // return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportContractExportReport = async (
  schoolProposalId,
  schoolName,
) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-pronto-price-contract`,
      { responseType: 'blob' },
    );
    if (res.status === 204) {
      showAlert('warn', 'No products associated with this proposal');
      return;
    }
    let fileName = `contract-report-${schoolName}.csv`;
    let alertType = 'success';
    let alertMsg = 'Contract report downloaded successfully';
    if (res.status === 409) {
      fileName = `contract-report-409(error)-${schoolName}.csv`;
      alertType = 'warn';
      alertMsg = 'Contract report downloaded with warnings (409)';
    }
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert(alertType, alertMsg);
  } catch (error) {
    // If error is 409, try to download file from error.response.data
    if (error?.response?.status === 409 && error?.response?.data) {
      const url = window.URL.createObjectURL(new Blob([error.response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `contract-report-409(error)-${schoolName}.csv`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      showAlert('warn', 'Contract report downloaded with warnings (409)');
    } else {
      console.log(error);
    }
  }
};
